import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const tronWalletSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getTronBalance: build.query<any, void>({
      query: () => `${urlConfig.walletsBaseUrl}/wallets/tron/balance`,
    }),
    getResources: build.query<any, void>({
      query: () => `${urlConfig.walletsBaseUrl}/wallets/tron/resource`,
    }),
    getTransactions: build.query<any, void>({
      query: () => `${urlConfig.walletsBaseUrl}/wallets/tron/transactions`,
    }),
    getTransactionsUsdt: build.query<any, void>({
      query: () => `${urlConfig.walletsBaseUrl}/wallets/tron/transactions/usdt`,
    }),
    getTronWallet: build.query<any, void>({
      query: () => `${urlConfig.walletsBaseUrl}/wallets/tron`,
    }),
    transferTrx: build.mutation({
      query: body => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/tron/transfer/trx`,
        method: 'POST',
        body,
      }),
    }),
    transferUsdt: build.mutation({
      query: body => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/tron/transfer/usdt`,
        method: 'POST',
        body,
      }),
    }),
    sellUsdt: build.mutation({
      query: body => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/tron/sell`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Wallet'],
    }),
    estimateTrxFee: build.mutation({
      query: body => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/tron/estimate/trx`,
        method: 'POST',
        body,
      }),
    }),
    estimateUsdtFee: build.mutation({
      query: body => ({
        url: `${urlConfig.walletsBaseUrl}/wallets/tron/estimate/usdt`,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useGetResourcesQuery,
  useEstimateTrxFeeMutation,
  useEstimateUsdtFeeMutation,
  useGetTransactionsQuery,
  useGetTronBalanceQuery,
  useGetTronWalletQuery,
  useSellUsdtMutation,
  useTransferTrxMutation,
  useTransferUsdtMutation,
  useGetTransactionsUsdtQuery,
} = tronWalletSlice
